import PropTypes from 'prop-types';
import React from 'react';
import {Bar, BarChart, CartesianGrid, ResponsiveContainer, XAxis, YAxis} from 'recharts';

const PercentageBarV2 = ({transactionsData}) => {
    return (
        <ResponsiveContainer width='100%' height={25}>
            <BarChart
                data={[{
                    ...transactionsData.reduce((acc, item) => ({
                        ...acc,
                        [item.name]: item.amount,
                    }), {}),
                }]}
                layout='vertical'
                barSize={25}>
                <CartesianGrid horizontal={false} vertical={false} />
                <XAxis type='number' hide />
                <YAxis type='category' hide />
                {transactionsData.map((item, index) => (
                    <Bar
                        key={item.name}
                        dataKey={item.name}
                        stackId='a'
                        fill={item.color}
                        radius={
                            index === 0
                                ? [30, 0, 0, 30]
                                : index === transactionsData.length - 1
                                    ? [0, 30, 30, 0]
                                    : [0, 0, 0, 0]
                        }
                    />
                ))}
            </BarChart>
        </ResponsiveContainer>
    );
};

PercentageBarV2.propTypes = {
    transactionsData: PropTypes.arrayOf(PropTypes.shape({
        amount: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
    })).isRequired,
};

export default PercentageBarV2;



// WEBPACK FOOTER //
// ./components/percentage-bar-v2/index.js